import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/layout', component: List, name: 'layout.index'},
  {path: '/layout/store', component: Form, name: 'layout.store'},
  {path: '/layout/:id', component: Form, name: 'layout.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/layout/routes.js